import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomerTypeEnum } from '../../../types/customerTypeSelection';
import { saveAndContinueRehydrateSlice } from '../storeUtils';

/**
 * - If you have piece of data that is not part of JourneyModel,
 * has to be globally accessible, and did graduate to be part of collection
 * forming a redux module of it's own - put it here.
 */
type UiState = {
  isSummaryMode: boolean;
  customerType: CustomerTypeEnum | null;
  isAnySectionInEditMode: boolean;
  allFormsSubmitted: boolean;
  snCSubmitted: boolean;
  snCClosed: boolean;
  shownCustomerSearchModal: boolean;
};

const initialState: UiState = {
  isSummaryMode: false,
  customerType: null,
  isAnySectionInEditMode: false,
  allFormsSubmitted: false,
  snCSubmitted: false,
  snCClosed: false,
  shownCustomerSearchModal: false,
};

export const slice = createSlice({
  name: 'uiState',
  initialState,
  selectors: {
    isSummaryMode: (state: UiState) => state.isSummaryMode,
    isAnySectionInEditMode: (state: UiState) => state.isAnySectionInEditMode,
    selectCustomerType: (state: UiState) => state.customerType,
    allFormsSubmitted: (state: UiState) => state.allFormsSubmitted,
    snCSubmitted: (state: UiState) => state.snCSubmitted,
    snCClosed: (state: UiState) => state.snCClosed,
    shownCustomerSearchModal: (state: UiState) => state.shownCustomerSearchModal,
    // TODO: PC-3264 - Remove this guard and use snCSubmitted directly once SnC flow is stable.
    // This always returns true to replicate the PC-3264 hack where SnC completion guard was disabled.
    snCSubmittedMock: () => true,
  },
  reducers: {
    setSummaryMode: (state, action: PayloadAction<boolean>) => {
      state.isSummaryMode = action.payload;
    },
    setCustomerType: (state: UiState, action: PayloadAction<CustomerTypeEnum | null>) => {
      state.customerType = action.payload;
    },
    setIsAnySectionInEditMode: (state: UiState, action: PayloadAction<boolean>) => {
      state.isAnySectionInEditMode = action.payload;
    },
    setAllFormsSubmitted: (state: UiState, action: PayloadAction<boolean>) => {
      state.allFormsSubmitted = action.payload;
    },
    setSnCSubmitted: (state: UiState, action: PayloadAction<boolean>) => {
      state.snCSubmitted = action.payload;
    },
    setSnCClosed: (state: UiState, action: PayloadAction<boolean>) => {
      state.snCClosed = action.payload;
    },
    setShownCustomerSearchModal: (state: UiState, action: PayloadAction<boolean>) => {
      state.shownCustomerSearchModal = action.payload;
    },
    resetUiState: () => initialState,
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, 'uiState');
  },
});

export const uiStateSlice = slice;
export const uiStateActions = slice.actions;
export const uiStateSelectors = slice.selectors;
